var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{on:{"click":function($event){return _vm.$emit('perform', 'openContainer', _vm.content)}}},[_c('div',{staticClass:"wrapper",style:(_vm.spiritColor)},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.attributes.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }